import React from 'react'

const SvgRelationshipOneAOneTwo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 962.1 1007.4">
    <defs>
      <clipPath id="clip-path" transform="translate(.7 .2)">
        <path
          d="M415.4 230.5c-3.5.1-5.4-2.8-6.2-4.1-.1-.2-.1-.5.1-.5 0 0 3.8 0 6.2-.1s6.3-.6 6.3-.6c.2 0 .4.3.2.7-.6 1.3-2.9 4.5-6.6 4.6Z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
      <style>
        {
          ".cls-30,.cls-31,.cls-45,.cls-46,.cls-53{fill:none}.cls-5{fill:#cbd9e2}.cls-6{fill:#f6f4e1}.cls-7{fill:#fff}.cls-8{fill:#abc0ca}.cls-9{fill:#bccdd8}.cls-10{fill:#adc2ce}.cls-12{fill:#94aebc}.cls-15{fill:#dba795}.cls-16{fill:#333}.cls-17{fill:#e8a18e}.cls-18{fill:#713a39}.cls-19{fill:#a32b28}.cls-20{fill:#a02410}.cls-21{fill:#ad6b55}.cls-22,.cls-24{opacity:.2}.cls-23,.cls-24{fill:#9e695c}.cls-24{isolation:isolate}.cls-26{fill:#ff7a5a}.cls-27{fill:#161b43}.cls-30,.cls-31{stroke:#7c4b87}.cls-30,.cls-31,.cls-46,.cls-53{stroke-linecap:round}.cls-30,.cls-46,.cls-53{stroke-linejoin:round}.cls-31,.cls-45{stroke-miterlimit:10}.cls-38{fill:#061a47}.cls-39{fill:#352d2d}.cls-45{stroke:#0e2651}.cls-46{stroke:#75d1c6}.cls-51{fill:#564444}.cls-53{stroke:#757575}.cls-55{fill:#097263}"
        }
      </style>
    </defs>
    <g id="Layer_1" data-name="Layer 1">
      <path
        d="M-.4-.2 0 1007.2l7.3-6.7 1.5-1.3c304.5-300 495.1-232 621.9-265.1 56.3-14.7 166.5-81.4 193.9-132.4.5-1-.4 1.3.1.4 15.9-30.9 22.2-69.5 16.1-103.7C781.5 168.4 961.4 0 961.4 0"
        transform="translate(.7 .2)"
        style={{
          fill: "#ffeab0",
        }}
      />
      <path
        d="M0 1007.2c304.5-300 503-240 629.7-273.2 56.3-14.7 166.5-81.4 193.9-132.4.5-1-.4 1.3.1.4 15.9-30.9 22.2-69.5 16.1-103.7C782.2 177.3 950.8 9.2 960 .4c-10.5 8.8-202.4 172.5-179.2 481.9a159.07 159.07 0 0 1-15.8 82.8c-19.3 38.7-59.9 87.6-145.3 125a216.19 216.19 0 0 1-84.2 18.1c-65.9.9-211.1 11.4-305.2 81.6 0 0-177.9 120.6-230.3 216.4"
        transform="translate(.7 .2)"
        style={{
          fill: "#ef6043",
        }}
      />
      <path
        d="M695.8 594.8a24.13 24.13 0 0 0-.8 2.5 40 40 0 0 1-12.5 22.3c-9.9 9.2-22 13.1-35.2 13.1H239.1c-2.4 0-4.7.1-7.1 0-11.5-.5-18.8-7.5-18.8-18.6-.1-20.1 0-40.2 0-60.3-.1-1.1-.1-2.3-.2-3.4h-4.2l-.2 3.4c0 20.6.2 41.1 0 61.7-.1 8.6-4.5 14-12.6 16.1a37.44 37.44 0 0 1-8.8 1.3H-.5v2.6h496.4c55.1 0 110.2.2 165.3-.1 20.1-.1 31.7-8.6 34.3-29.9.5-3.4 2.1-7.1.3-10.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#939fa5",
        }}
      />
      <path
        className="cls-5"
        d="M195.7 525c-11.5-7.5-24.8-10.3-38.3-11-14.5-.7-29-.2-43.5-.2-2.1 0-4.2.4-4.5 2.6-.6 3.6-3.5 3.9-5.9 4.3-4.7.7-9.4.7-14.1 1.1-7.1.7-14.1 1.3-21.1 2.2-11.7 1.5-23.3 3.2-34.9 4.9-11.3 1.6-22.5 3.2-33.8 5.1v19.9h209l.2-3.4c1.3-11.5-4.3-19.7-13.1-25.5ZM661.1 349.7c-2.8-2.6-6.3-3.9-9.8-5.3H-.5v23.1h667.8c.5-6.8-.6-13.1-6.2-17.8Z"
        transform="translate(.7 .2)"
      />
      <path className="cls-6" d="M.2 392h60v90H.2z" />
      <path className="cls-7" d="M318.2 411h98v67h-98z" />
      <path
        className="cls-8"
        d="M653.5 367.5H-.5v41.7c14.2-.7 28.2-2.9 42.2-4.9 15.2-2.1 30.4-4.4 45.5-7.5 5.2-1.1 7.4.5 7.9 6 1.7 15.8 3 31.8 4.8 47.6 2 17.2 5.4 34.1 8.8 51a36.57 36.57 0 0 1 .5 5.7c.2 4-1.8 5.9-5.8 6.3-29.5 2.6-58.8 6.2-88 11-5.4.9-10.7 1.7-16.1 2.6v7c11.3-1.8 22.6-3.4 33.9-5.1 11.6-1.7 23.3-3.4 34.9-4.9 7-.9 14.1-1.6 21.1-2.2 4.7-.4 9.4-.4 14.1-1.1 2.4-.4 5.3-.6 5.9-4.3.4-2.2 2.5-2.6 4.5-2.6 14.5 0 29-.5 43.5.2 13.5.7 26.8 3.6 38.3 11 8.8 5.7 14.4 13.9 13.1 25.3h4.2a24.78 24.78 0 0 1 5.6-19c4.1-5 9.6-8.3 15.5-10.6 10.5-4.1 21.3-6.9 32.7-6.9h144.9c1.9 0 3.8-.1 5.8-.1q2.25-28.65 1.7-57.5c-.4-11.6-1.5-23.2-2.4-34.8a45.09 45.09 0 0 1 1-11c.5-2.9 2.8-3.4 5.5-3.3 10.3.4 20.7.8 31 .9 19.2.1 38.5.2 57.7-.1 7.4-.1 14.8-.8 22.2-.8a12.2 12.2 0 0 1 5.6 1.1 45.47 45.47 0 0 1 2.9-14.2c1.4-3.7 4-4.5 7.4-3.6 15.1 4 30.1 8.3 45.2 12 14.3 3.6 28.6 7.2 43 10.1 6.2 1.2 12.4 2.5 18.6 3.5h.3a6.32 6.32 0 0 1 4.9 7.5c-1 4.7-2 9.5-4.1 13.9-3 10.9-6.1 21.8-8.9 32.7-4.3 16.8-7.5 33.9-10.6 51-.3 1.8-1.3 3.3-1.6 5-.8 4.5-3.5 5.2-7.5 4.1-11.7-3.3-23.3-6.6-35-9.6-14.3-3.6-28.7-6.8-43-10.2-3.6-.8-7.2-1.5-10.8-2.3-.4 2.2-.6 4.5.6 6.5 7.9.6 15.5 2.8 23.2 4.7 6.7 1.6 13.5 3 20.2 4.7 14.9 3.9 29.8 8.1 44.7 12.1 4.8 1.3 6.4.2 8.1-4.7 1-2.9 2.5-5.7 2.6-8.9.1-2.4 1.6-2.6 3.8-2.1 5.5 1.2 10.3 4.2 15.7 5.7.9-15.6 1.8-31.3 2.6-47 .4-7.3.6-14.7.9-22-.6-15.3 2.9-30.4 1.9-45.6a3 3 0 0 1 .8-2.4l.3-13.3c-.2-1.5-.7-3.1.6-4.4l.2-8.9v-1.8c.2-4.4.4-8.9.6-13.3l-13.7.1Zm-420.4 75.3c-3.7 1.3-7.6 1-11.4 1-7 0-10.5 3.4-10.4 10.2a31.16 31.16 0 0 1-1.2 10.5c-.3.8-.5 1.9-1.6 1.9-1.4 0-1.6-1.2-1.7-2.2-.2-3.7.4-7.4-.6-10.7a9 9 0 0 0-9-9.8c-4.1-.1-8.3.6-12.3-.8-.8-.3-1.9-.2-1.9-1.4s1-1.3 1.9-1.3c2.9-.2 5.8-1.5 8.8-.9 5.2 1.1 8.8-1.2 12-4.9a4.89 4.89 0 0 0 1-3.7v-11.1c0-1.3 0-3 1.8-3 1.5 0 1.7 1.4 1.7 2.6.2 2.9 1.1 5.8 1 8.8-.2 8.3 2.9 11.2 11.1 11.2 3.5 0 7.1-.1 10.5.9.7.2 1.6-.1 1.8.9.3 1.3-.6 1.5-1.5 1.8Zm160.5.1c-4.2 1.4-8.5.8-12.8.9s-8.6 4.1-8.6 8.5a63.69 63.69 0 0 1-.9 12.3c-.2 1.1-.1 2.7-1.7 2.6-1.4-.1-1.7-1.6-1.8-2.7a93 93 0 0 1-.2-11.8c.3-4.3-4.4-8.7-8.7-8.9-4-.2-8 .6-11.9-.8-.9-.3-2.3-.1-2.2-1.6a2.16 2.16 0 0 1 2.2-1.8c2.5-.3 5-.3 8.1-.4 4.8 1.9 8.1-1.4 11.4-4.7 1.1-1.1 1.1-2.4 1.1-3.7.1-4 0-8 .1-12 0-1.3 0-3.1 1.8-3s1.6 1.8 1.7 3.1c.3 3.2.8 6.4.8 9.7.1 7.8 3.1 10.8 10.9 10.8 3.5 0 7.1-.3 10.5.9.7.3 1.5.5 1.5 1.4.2.8-.6 1-1.3 1.2Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-9"
        d="M208.6 553.9H-.4v79h187.7a37.44 37.44 0 0 0 8.8-1.3c8.1-2.1 12.5-7.5 12.6-16.1.1-20.5-.1-41.1-.1-61.6Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-10"
        d="M754.5 447.4a1.84 1.84 0 0 1-1.8-1.7c-15.2-6.8-30.7-4.2-46.2-1-.9 9.8-1.8 19.6-2.7 29.3-1.1 12.5-2.6 25.1-3.4 37.7-.8 12-2.7 24-2.9 36a32.49 32.49 0 0 1-1.8 10.7v36.5c1.8 3.6.1 7.3-.3 10.7-2.6 21.3-14.1 29.7-34.3 29.9-55.1.4-110.2.1-165.3.1H.4v56.8h330.8c1.4 0 3 .1 4.4.1q72.3-.15 144.5-.1c9.9 0 19.8.1 29.7.1h136c6.9-.5 13.8.2 20.8-.5 9.5-1.1 18.7-3.4 28.1-5a17.38 17.38 0 0 1 1.9-1c20.3-7.8 35.3-21.1 44.2-41.2 3.2-7.3 4.7-15 7-22.5 2.1-24.8 4.3-49.7 6.4-74.5a55.09 55.09 0 0 0 .6-5.7c.5-14.5 2.3-29 3.1-43.5.3-5.2-.3-10.6 1.4-15.6 0-1.8.1-3.5.1-5.3.6-10.6 1.3-21.1-4.9-30.3Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M657.6 761.5a54.63 54.63 0 0 0 1 6.9c.9 3-.1 3.5-3 3.9-7.2.9-12.5-.9-15.4-8a28.46 28.46 0 0 0-2.3-3.7l-20.5-31c-1.5-2.2-2.8-4.5-4.4-6.6-7.2-9.8-14.5-19.5-19.7-30.6H646c2 11.2 3.9 22.5 5.9 33.7 1.3 11.9 3.6 23.7 5.7 35.4Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#8e4910",
        }}
      />
      <path
        className="cls-9"
        d="M695.8 558.3v36.5a24.13 24.13 0 0 0-.8 2.5 40 40 0 0 1-12.5 22.3c-9.9 9.2-22 13.1-35.2 13.1q-204.15.15-408.2 0c-2.4 0-4.7.1-7.1 0-11.5-.5-18.8-7.5-18.8-18.6-.1-20.1 0-40.2.1-60.3h480Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-12"
        d="m695.8 558.3-2.6-4.5a15.29 15.29 0 0 0-4.1-7.2c-8.2-9.2-18.8-15-29.7-20.4.9-15.7 1.8-31.4 2.6-47 .4-7.3.6-14.7.9-22 4.8-.2 8.9-2.8 13.4-4.2 10-3 19.8-6.5 30.2-8.4-.9 9.8-1.8 19.6-2.7 29.3-1.1 12.5-2.6 25.1-3.4 37.6-.8 12-2.7 23.9-2.9 36a29.84 29.84 0 0 1-1.7 10.8Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-5"
        d="M213.2 553.8c-.1-1.1-.1-2.3-.2-3.4a24.78 24.78 0 0 1 5.6-19c4.1-5 9.6-8.3 15.5-10.6 10.5-4.1 21.3-6.9 32.7-6.9h144.9c1.9 0 3.9-.1 5.8-.1.4 3-1.5 6 .1 9-1.3 4.2.5 7 4.7 7.1 7.5.1 15-.5 22.5-.7 23.1-.4 46.1-.4 69.2 0 7 .1 14.1.7 21.2.7 4.5 0 6.4-2.8 5-7.2-.3-2.7.6-5.3 1-8 7.9.6 15.5 2.8 23.2 4.7 6.7 1.6 13.5 3 20.2 4.7 14.9 3.9 29.8 8.1 44.7 12.1 4.8 1.3 6.4.2 8.1-4.7 1-2.9 2.5-5.7 2.6-8.9.1-2.4 1.6-2.6 3.8-2.1 5.5 1.2 10.3 4.2 15.7 5.7 10.9 5.4 21.4 11.2 29.7 20.4a15.29 15.29 0 0 1 4.1 7.2Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-6"
        d="M417.5 522.8c-1.7-3 .3-6-.1-9q2.25-28.65 1.7-57.5c-.3-11.6-1.5-23.2-2.4-34.8a45.09 45.09 0 0 1 1-11c.5-2.9 2.8-3.4 5.5-3.3 10.3.4 20.7.8 31 .9 19.2.1 38.5.2 57.7-.1 7.4-.1 14.8-.8 22.2-.8a12.2 12.2 0 0 1 5.6 1.1c.2.9.3 1.8.5 2.6a9.65 9.65 0 0 0 .1 8.9c0 2.6.3 5.3-.4 7.9-2 .8-4.1 2.3-6.1 2.3-10.4-.3-18.8 5.3-27.6 9.3-5.8 2.6-10.6 7.1-16.4 9.8a17.69 17.69 0 0 0-5 3.6c-7.6 7.4-14.9 15-22.6 22.4-3.3 3.2-5.2 7.2-8.2 10.6-4.7 5.4-8 11.8-11.3 18.1-3.4 6.5-9 12.1-9 20.1-5.5.8-11 2.1-16.2-1.1Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M433.6 523.8c0-8 5.6-13.6 9-20.1 3.3-6.3 6.6-12.6 11.3-18.1 3-3.4 4.9-7.4 8.2-10.6 7.6-7.3 15-15 22.6-22.4a17.69 17.69 0 0 1 5-3.6c5.8-2.7 10.6-7.2 16.4-9.8 8.9-4 17.2-9.6 27.6-9.3 2 .1 4.1-1.5 6.1-2.3.9 3.3-.5 6.4-.5 9.7 0 7.7-.1 15.4-.3 23-.3 11.3.1 22.7.7 34-.5 2.4.4 4.7.5 7.1l.1 1.7.2 5.1c-.4 2.2-.6 4.4.6 6.5-.4 2.7-1.3 5.2-1 8a7.91 7.91 0 0 1-5.7 1.9c-4.6.1-9.1-.8-13.7-.8Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#f8f5cf",
        }}
      />
      <path
        className="cls-12"
        d="M206.3 453.5c.2-5.6-3.6-9.6-8.9-9.8-4.1-.1-8.3.6-12.3-.8-.8-.3-1.9-.2-1.9-1.4s1-1.3 1.9-1.3c2.9-.2 5.8-1.5 8.8-.9 5.2 1.1 8.8-1.2 12-4.9a5.42 5.42 0 0 0 1.1-3.7v-11.1c0-1.3 0-3 1.8-3 1.5 0 1.6 1.4 1.7 2.6.2 2.9 1 5.8 1 8.8-.2 8.3 2.9 11.3 11.1 11.2 3.5 0 7.1-.1 10.5.9.7.2 1.6 0 1.8.9.2 1.1-.8 1.4-1.6 1.7-3.7 1.2-7.6 1-11.4 1-7 0-10.5 3.4-10.4 10.2a31.16 31.16 0 0 1-1.2 10.5c-.3.8-.5 1.9-1.6 1.9-1.4 0-1.6-1.1-1.6-2.2-.4-3.6.2-7.3-.8-10.6Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-10"
        d="M433.6 523.8c29.1 0 58.2-.1 87.3 0 4.5 0 9.1.9 13.7.8a8.37 8.37 0 0 0 5.7-1.9c1.4 4.4-.5 7.2-5 7.2-7.1 0-14.2-.6-21.2-.7-23.1-.4-46.1-.4-69.2 0-7.5.2-15 .8-22.5.7-4.2 0-6-2.9-4.7-7.1 5 3.2 10.5 1.9 15.9 1Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M540.3 501.5c.8.5.9 1.1.1 1.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#ebb452",
        }}
      />
      <path
        className="cls-15"
        d="M166.4 551.2c-4.5 4-15.7 8.2-22 17.1-6.7 9.6 4.2 57.7-1.7 61.8-12.4 8.5-12.4-33.9-20.5-42.3-12.3-12.8-19.6-19.3-17.9-26.1 1.7-6.6 9.9-5.6 22.9-16.1 13.4-10.9 18.8-16.6 21.5-18.8l8.4 11.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-16"
        d="m99.6 560.2 7.5-4.9a33.78 33.78 0 0 1 7.4-3.6l5.5-1.8.8-.3a2.13 2.13 0 0 1 2.7 1.4 2.85 2.85 0 0 1 0 1.3l-.5 1.9a14.81 14.81 0 0 0 12.1 17.1l2.2-2.2a7.89 7.89 0 0 1 8-1.9 2.6 2.6 0 0 1 1.6 2.4s-1.3 16.1-1.3 16.3 0 .5-.1.6 0 .5-.1.7 0 .3 0 .4v.1c0 .2-.2 6-.2 6.1s.1 3.3.1 3.5v1.3c0 .5.1 1 .1 1.5v.3c0 .1.5 3.7.6 4.4v.2a5.76 5.76 0 0 1 .2 1 6.37 6.37 0 0 0 .2.9c.2.9.6 2.7.6 2.8.1.3.1.5.2.8v.2l.2.8a78.33 78.33 0 0 0 2.5 7.8l3.9 10.1a10 10 0 0 1-3.8 11.9h-.1l-.3.2a14.52 14.52 0 0 1-6.1 1.9l-.2.1v-.1a13.35 13.35 0 0 1-11.4-5.2 5.55 5.55 0 0 1-.6-.8l-40.2-61.6c-2.3-3.5-2.1-7.4.9-10.1.4-.4 1.3-.7 1.6-.3l2.6-2.5a28.76 28.76 0 0 1 3.4-2.7Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-17"
        d="M424.2 589.3c-3.5 4.9-6.6 16.5-14.9 23.6-8.9 7.6-57.9 1.5-61.3 7.8-7.2 13.1 31.4 11.8 40.5 19.1 13.9 11 24.7 14.8 31.3 12.4 6.4-2.3 4.6-10.4 13.8-24.3 9.5-14.4 14.7-20.4 16.5-23.2l-12.3-7.3ZM462.5 643.2c-.6 6 2.6 17.5-1 27.9-3.8 11-49.3 30.3-49.1 37.5.4 15 33.1-5.5 44.6-3.8 17.6 2.6 28.8.4 33.3-5s-1.3-11.3-.3-28c1-17.2 2.5-25 2.7-28.4l-14.3-.1Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-15"
        d="M247.5 553c.2 6-3.6 17.4-.6 27.9 3.2 11.2 48.2 27.1 47.6 34.2-1.3 14.9-34.9-5.7-46.5-4.7-17.7 1.5-27.3 3-31.5-2.6s1.9-11.2 2-27.9c0-17.3-1-25.1-1-28.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-16"
        d="m211.9 607 .8-9a31.93 31.93 0 0 1 1.8-8l2-5.4.3-.8a2.19 2.19 0 0 1 2.8-1.3 2 2 0 0 1 1 .8l1.1 1.6a14.84 14.84 0 0 0 20.9 1.2l-.4-3.1a7.69 7.69 0 0 1 3.5-7.5 2.42 2.42 0 0 1 2.9.3l12 11.2.4.4.5.5.3.3h.1c.1.1 4.6 3.8 4.7 3.9l2.8 2 .3.2.5.4.2.1c.4.3.8.5 1.2.8l.2.2c.2.1 3.2 1.9 3.8 2.3l.2.1a9 9 0 0 0 .9.5l.8.4c.8.4 2.5 1.2 2.5 1.2l.7.3.2.1.8.3a71.47 71.47 0 0 0 7.7 2.9l10.3 3.2a10 10 0 0 1 7 10.4v.1l-.1.4a13.77 13.77 0 0 1-2.3 5.9l-.1.2h-.1a13.26 13.26 0 0 1-11.1 5.7l-1-.1-73.3-6.6c-4.2-.4-7.1-2.9-7.4-7 0-.6.2-1.4.8-1.5l-.3-3.6c0-1.2 0-2.6.1-4Z"
        transform="translate(.7 .2)"
      />
      <ellipse
        className="cls-18"
        cx={639.68}
        cy={279.8}
        rx={13.3}
        ry={18.5}
        transform="rotate(-30 640.429 278.602)"
      />
      <ellipse
        className="cls-18"
        cx={691.62}
        cy={277.38}
        rx={15.9}
        ry={10.2}
        transform="rotate(-77.56 692.103 277.047)"
      />
      <path
        className="cls-19"
        d="M391.6 180.1s11.1 8.8 16.2-2.9-.2-19.7-7.7-20.2-18.1 11.1-14.8 16.3 6.3 6.8 6.3 6.8Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-20"
        d="M433.1 157.3c-31-4.5-45.3 15.2-38.4 41.8 5.3 20.3 16.8 36.9 37.8 36.9 9.6 0 20.8-6.5 20.8-6.5 7.1 7 24.8-17.6 16.8-42.4-5-16-15.9-26.7-37-29.8Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-21"
        d="M350.3 344.9c-11.6-6.8 16-75.7 29.5-90.2 8.6-9.3 17.4-9.3 30.5-13.9 9.8-3.5 28.6-1 38.8-.9 22.4.3 47.6 5.2 57.3 16.4 11.3 13.1 1.4 40 4.7 63.2 1.7 11.6 1 21.6-.8 25.5h-160Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-21"
        d="m453.2 249.3-2.8-13c2.3-1.8 10.5-16.1 10.8-26.2.8-21.6-11.2-41-28.5-43.2-19.9-2.5-32 12.7-35.3 34.1s7 42.2 24.1 44.9l1.8 9.6a15.37 15.37 0 0 0 17.5 12.4l.4-.1a15.36 15.36 0 0 0 12.1-18 1.34 1.34 0 0 1-.1-.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-20"
        d="M411.4 200c.6-.9.1-1.7-1.6-2.2a15.08 15.08 0 0 0-5.2-.4c-3 .3-5.5 2.9-4.6 2.7a18.87 18.87 0 0 1 6.7-.6c1.9.1 4.2 1.1 4.7.5Z"
        transform="translate(.7 .2)"
      />
      <g className="cls-22">
        <path
          className="cls-23"
          d="M413.4 212.9a19.75 19.75 0 0 1-.8 2.6 10.55 10.55 0 0 0-.5 1.9 1.72 1.72 0 0 0 .2 1.2 1.87 1.87 0 0 0 1.4.5 2.47 2.47 0 0 0 1.9-1.2c.1-.1 0-.2-.1-.3s-.2 0-.3.1a1.89 1.89 0 0 1-1.9 1c-.5-.1-.9-.3-.9-.8a6.69 6.69 0 0 1 .5-1.9c.3-.9.6-1.9.9-2.9.1-.3-.3-.5-.4-.2Z"
          transform="translate(.7 .2)"
        />
      </g>
      <path
        className="cls-24"
        d="m422.5 250.8-1-5c17.2-1.3 23.8-11.3 23.8-11.3-4.9 8.4-9.8 16.3-22.8 16.3Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M460.1 212.2a7.3 7.3 0 1 1-6.4-8.1 7.3 7.3 0 0 1 6.4 8.1Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#ffa18a",
        }}
      />
      <path
        className="cls-26"
        d="M455.5 209.2a5.85 5.85 0 0 0-2.1 1.7 6.11 6.11 0 0 0-.8 3c0 .5-.9.6-.8 0a6.74 6.74 0 0 1 1-3.4 6.41 6.41 0 0 1 2.5-2.1c.2-.1.4 0 .5.3.1.2 0 .4-.3.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-26"
        d="M453 210.6a2.66 2.66 0 0 1 2.2 1.1 2.33 2.33 0 0 1 0 2 1.76 1.76 0 0 1-.8.9c-.2.1-.5.1-.6-.1a.44.44 0 0 1 .1-.5l.1-.1.1-.1.1-.1.1-.2.1-.2v-1c0-.1 0-.1-.1-.2v-.1a.1.1 0 0 0-.1-.1l-.1-.1-.1-.1a.31.31 0 0 0-.2-.1l-.1-.1h-.1l-.3-.1h-.3c-.2 0-.4-.3-.4-.5s.2-.3.4-.4Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-20"
        d="M421 201.5c-.6-.9-.1-1.7 1.6-2.2a15.08 15.08 0 0 1 5.2-.4c3.1.3 5.5 2.9 4.6 2.7a18.87 18.87 0 0 0-6.7-.6c-2 0-4.3 1.1-4.7.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-27"
        d="M402.5 210.2a4 4 0 0 1 5.2-.3c.3.3.9-.2.5-.5a4.45 4.45 0 0 0-3.1-1 4 4 0 0 0-3.2 1.3c-.3.4.3.9.6.5ZM422.2 210.1a3.36 3.36 0 0 1 2.8-1.1 4 4 0 0 1 2.8.8c.2.1.4.1.5-.1a.45.45 0 0 0 0-.5 4.43 4.43 0 0 0-3.3-1.1 4.07 4.07 0 0 0-3.4 1.4c-.2.4.4.9.6.6Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M442.4 323.8c8-1.5 15.9-3.3 23.8-5.2 4-.9 7.9-1.9 11.9-2.7a46.55 46.55 0 0 1 11.8-1.5 20.76 20.76 0 0 1 11.8 3.6c.4.3.8-.4.4-.6-6.1-4.4-13.9-4.1-21-2.8-8.3 1.6-16.5 3.8-24.7 5.7-4.7 1.1-9.4 2.1-14.2 3-.5-.1-.3.6.2.5Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#8e5a50",
        }}
      />
      <g className="cls-22">
        <path
          className="cls-23"
          d="M381.3 253.8a32.49 32.49 0 0 1 10.8 14.3 41.13 41.13 0 0 1 2.2 16c-.4 10.2-3.5 20-4.7 30.1-.5 4-.6 8.4 1.3 12 .2.4.9 0 .6-.4-1.8-3.3-1.7-7.4-1.3-11 .5-4.9 1.6-9.7 2.5-14.5 2-10.2 3.8-21.2.4-31.4a33.94 33.94 0 0 0-11.3-15.6c-.4-.3-.9.2-.5.5Z"
          transform="translate(.7 .2)"
        />
      </g>
      <path
        d="M172.6 313c19.1-11.5 66.3-32.7 133.1-16a17.12 17.12 0 0 1 11.9 10.3c6.8 17.7 22.3 61.8 23.8 100.3a12.1 12.1 0 0 1-9.8 12.3c-27.6 5.7-101.7 25.5-111.1 28.4-16.2 5-36.7-91.6-52-121.1a10.57 10.57 0 0 1 4.1-14.2Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#93529e",
        }}
      />
      <path
        className="cls-30"
        d="M296.7 319s36.6 33.8 0 65.2M308 315.7s.9 4.6 0 7"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-31"
        d="M306 398.3s-1.3 19.6-75.8 41.9"
        transform="translate(.7 .2)"
      />
      <path
        d="M204.3 425.6s-1.7-23.3 1.4-32.3"
        transform="translate(.7 .2)"
        style={{
          strokeMiterlimit: 10,
          stroke: "#7c4b87",
          fill: "none",
        }}
      />
      <path
        className="cls-31"
        d="M178.1 329s22.6 26.7 26.7 52.8"
        transform="translate(.7 .2)"
      />
      <path
        d="M570.2 373.4a12.78 12.78 0 0 0-7.5-6.9 12.11 12.11 0 0 0-6.8-.4l.3-2.8h-46.6l5 41.5 37.3.5 1.7-15.3a21.53 21.53 0 0 0 8-.1c3.7-.7 7-2.7 8.6-6.2a12.35 12.35 0 0 0 0-10.3Zm-3.7 6s-.1.5-.1.6c-.1.4-.2.8-.3 1.1l-.1.2-.2.3a3.51 3.51 0 0 1-.5.8l-.3.4c.1-.1.3-.3 0 .1s-.5.5-.7.8l-.2.2-.1.1a4.67 4.67 0 0 1-1 .5c-.2.1-.5.2-.7.3a5.64 5.64 0 0 0-1.2.4 16.53 16.53 0 0 1-7 .1l1.4-14 .5-.2 1.2-.3a7.36 7.36 0 0 1 3.3.1c.3.1.6.2 1 .3l.3.1.3.1a3.51 3.51 0 0 1 .8.5l.4.2.2.2a15.38 15.38 0 0 1 1.3 1.2l.2.3.1.2a8.79 8.79 0 0 1 .6 1c.1.2.3.5.4.7a4.17 4.17 0 0 1 .2.6 2.92 2.92 0 0 1 .2.9l.1.3v.3a9.15 9.15 0 0 1-.1 1.6Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#fcfbf0",
        }}
      />
      <path
        d="M553.7 390.9c-.1 1.2-.2 2.5-.3 3.7l-.1.5a.25.25 0 0 0 .5 0l.4-3.7v-.5c0-.1-.5-.3-.5 0Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#d8d8d8",
        }}
      />
      <path
        className="cls-20"
        d="M408.4 175.2c4.5 8.3 25.7 10.4 44.6 34.5 1.9 2.5 5.6-2.3 8-5.4 5.5-7-2.4-28.6-18.4-36.3-14.2-6.9-37.5 1.1-34.2 7.2Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-19"
        d="M447.9 163s4.3-13.4 15.1-6.7 10.8 16.5 4.9 21.1-21.2.9-21.3-5.2 1.3-9.2 1.3-9.2Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-20"
        d="M441.5 202.1s1.1 43.1-2.1 57.6c.3-.5 3.6 0 3.6 0s6.9-30.4 6.3-39.3c1.1 1.1 1.9 7.7 2.9 10.8s9-2.1 9-2.1 7.5-50.1-16.4-59.7-3.3 32.7-3.3 32.7Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-20"
        d="M466.2 178.7s9.7 15.9 7.1 39.6a9 9 0 0 1-3.2 6.1l-16 13.8-9.7-12 3-23.4ZM402.4 174.2s9.4 13.7 18.9 15.5 15.6 20.1 15.6 20.1l3.1-20.1-15.8-15Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M64.7 463.5a76.12 76.12 0 0 0-25.8 15.8.42.42 0 1 0 .6.6 76.46 76.46 0 0 1 25.4-15.6c.6-.2.3-1-.2-.8Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#acadad",
        }}
      />
      <path
        className="cls-15"
        d="M123.8 369.1c1-23 29.4-29.7 29.4-29.7 5.2 5.4 17.6 28.6 36.1 35.6 5.9 2.3 75.6-24.9 86.6-30.8 6.8-3.7 19.3-14.2 34.3-13 18.1 1.5 14.4 32.9 1.4 34.9-11.2 1.7-12.5-7.5-20.4-4.5"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-7"
        d="M647.8 276.2c-3.4.5-5.8-.6-6.7-1.6a.3.3 0 0 1 0-.4l.1-.1s3.7-.3 6.1-.7 6.1-1.2 6.1-1.2c.2 0 .3 0 .3.3-.5 1.3-2.3 3.2-5.9 3.7Z"
        transform="translate(.7 .2)"
      />
      <path
        style={{
          fill: "#ea8f7d",
        }}
        d="m616.3 358.9 14.1 3.3-33.6 101-7-5.5 26.5-98.8z"
      />
      <path
        d="M409.5 602.8s32.5 17.9 43 17l22.5-50.6-20.5 88.6s18.8 7.5 22 8c5.6.9 20-1 20-1 26-75 39.8-146.8 45-150s43.8 33.8 79.1 34.2c42.2.5 62.1-23.6 60.5-52.6-.9-16-89-37.3-89-37.3-49.4-26.2-63-45.6-85.4-43-41.1 4.7-60.2 128.7-97.2 186.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#10a79e",
        }}
      />
      <path
        className="cls-38"
        d="M589.5 456.8s23.8 18.2 38 22c33.5 8.9 46.9 23.9 52 32.5a2.76 2.76 0 0 0 3.8.9 3.33 3.33 0 0 0 1.2-1.4c9.9-27.5 47.4-93.5 42.1-128.3l13.3 4.4c6.6-15 13.6-32 6.6-44s-25.1-22-47.6-25.4c-7.4-1.1-29.4-1.2-36.8-1.5a99.64 99.64 0 0 0-27.2 2.5c-26.6 5.6-29.3 31.2-35.1 51.2-.6 2.1 13.7 5.6 13.7 5.6-.1 11.5-6.7 21-8.1 32.5-2.1 18.9-5.7 33.8-15.9 49Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-17"
        d="m691.5 312 .5-44.6a39.93 39.93 0 0 0 3.3-15.2c.3-22.1-19.8-42.3-37.6-42-20.5.4-32.7 17.6-30.8 39.6s12.8 46.3 30.6 46.5c1.4 0-.4.2 1 0v19.4c-.1.1 22.8 6.7 33-3.7Z"
        transform="translate(.7 .2)"
      />
      <circle className="cls-17" cx={686} cy={256.9} r={7.5} />
      <path
        className="cls-39"
        d="M688.1 254.4a4.52 4.52 0 0 0-2.2 1.6 6.3 6.3 0 0 0-1 3c-.1.5-.9.5-.8 0a7.72 7.72 0 0 1 1.2-3.5 6 6 0 0 1 2.7-2 .38.38 0 0 1 .5.3c0 .4-.1.6-.4.6Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-39"
        d="M685.5 255.7a2.61 2.61 0 0 1 2.2 1.3 2.24 2.24 0 0 1-.1 2.1 2.36 2.36 0 0 1-.8.9.45.45 0 0 1-.4-.8l.1-.1.2-.1.1-.1c0-.1.1-.1.1-.2l.1-.2v-1c0-.1 0-.1-.1-.2v-.1l-.1-.1-.2-.2-.1-.1-.2-.2-.1-.1h-.2c-.1 0-.2-.1-.3-.1h-.4a.4.4 0 1 1 0-.8Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M658.5 302.5v-6.1c20.4 3.1 33.7-20.4 33.7-20.4-2.4 12.6-16.8 24-33.7 26.5Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#9e6352",
          opacity: 0.3,
          isolation: "isolate",
        }}
      />
      <path
        d="M475.3 569.8a365.63 365.63 0 0 0 27.9-58.6c2.2-5.9 4.2-11.9 6-17.9a.63.63 0 1 0-1.2-.4 352.25 352.25 0 0 1-24.7 60c-2.9 5.5-5.9 10.9-9.1 16.3a.63.63 0 0 0 .3.8.78.78 0 0 0 .8-.2Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#75d1c6",
        }}
      />
      <path
        className="cls-15"
        d="m156.7 270.9-1.4 23.4c-1.1 6.9 0 5.8-2.3 21.9a103 103 0 0 0-28.8-2.3c-27.1 1.4-19.2-14.7-19.2-14.7l5.1-1.4a12.46 12.46 0 0 0 9.4-12.5l-1-20.4Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-24"
        d="M119 277.8c8.8 7.2 24 14.7 37.4 4.9l.4-6.3-38.2-8.5Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-15"
        d="M110.8 260s8.9-.4 11.4-8.5c0-.1 11-44.4 26.6-44.6 18.5-.2 26.4 5.5 28.3 23.6.8 7.7 4.5 10.6 8.1 14.4a2.4 2.4 0 0 1-.3 3.4 2.51 2.51 0 0 1-1.9.5l-2.7-.1a1.19 1.19 0 0 0-1.2 1.1c-.8 10.3-5.6 24.6-8.8 27.1-2 1.6-9.7 3.9-16.9 4.4-27.6 1.6-42.6-21.3-42.6-21.3Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M170.6 240.1a1.37 1.37 0 0 1-1.9.6c-.1-.1-.2-.1-.3-.2a2.27 2.27 0 0 1-.4-2.7 1.37 1.37 0 0 1 1.9-.6c.1.1.2.1.3.2a2.13 2.13 0 0 1 .4 2.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#382632",
        }}
      />
      <path
        className="cls-38"
        d="M98.9 194.9c7.4-10.5 20.4-15.2 37-13.3 0 0 18.2 3 25 3.2.2 0 5.4 22.2 5.4 22.2a42.65 42.65 0 0 0-11.8 7.4c-4.8 4.3-8 13.6-8.5 18.3a48.44 48.44 0 0 0-.3 5.3v.3c-4.1 6.4-7.1.3-7.2.3v-2.8c0-.1-7.5 3.1-8.1 7.6-1.7 13.4-12.6 26-19.3 26-14.8 0-13.5-21.1-20.2-38.5-5.3-13.9.5-25.6 8-36Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-15"
        d="M123.8 239a7.3 7.3 0 0 0 8.3 5.9h.1a7.53 7.53 0 0 0 6.4-8.2c-.3-4.3-3.6-7.6-7.4-7.3-7 .5-8.1 5.5-7.4 9.6Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-24"
        d="M129.7 237.6a1.74 1.74 0 0 1 1.2-1.4 3.4 3.4 0 0 1 1-.1 4.21 4.21 0 0 0-1.6-1.9c-.3-.2 0-.8.3-.6a5 5 0 0 1 1.9 2.4 6.2 6.2 0 0 1 .2 3.3c-.1.4-.7.2-.6-.2a4.87 4.87 0 0 0 0-2.4h-.6c-.1 0-.2 0-.2.1h-.1c-.1 0-.1.1-.2.1h-.1a.1.1 0 0 0-.1.1v.1c0 .1-.1.1-.1.2v.1c0 .1 0 .1-.1.2v.6c0 .1 0 .1.1.2v.2l.1.2.1.1.1.1a.35.35 0 0 1-.5.5 3.7 3.7 0 0 1-.8-1.9Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M171.9 206.3c5.4-3.5 8.7-8.9 7.9-16.2-.5-4.6-1.1-11.2-7.9-12.9-2.8-.7-13.4-10.6-21.7-9.3-7.5 1.2-11.9 6.1-19.9 8-12.3 3-18.5 7.1-19 11.6s2.1 8.4-1.1 14.1c-3.6 6.6-7 7.6-8.4 12.9-.8 2.8 1.1 3.1 4.7 12.6 2.7 7.1 1 12.1 3.4 13.2 4.8 2.2 7.7-4.3 12-5.2 5.7-1.2 10.2-4.1 10.6-4.7 3.1-4.4-2.1-9.4.5-12.2 2.9-3 9.8 2.8 19.6.3 6-1.5 13.6-1.4 15.3-2.9 5.6-5 .5-7 4-9.3Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#02594f",
        }}
      />
      <path
        className="cls-7"
        d="M177.5 260.1a4.51 4.51 0 0 1-.3 1.1 8.66 8.66 0 0 0-.2 1l-.2.9c-6.9 2-9.6-3.7-8.4-3.2a21.42 21.42 0 0 0 9.1.2Z"
        transform="translate(.7 .2)"
      />
      <path
        d="m145.8 237.3 16.3-1a11.48 11.48 0 0 0 0 3.7c.8 5.6 5 9.6 9.4 9 4.1-.6 6.9-5 6.7-10.1l1.7-.2c-.3-.6-.7-1.2-1-1.7l-1 .1c-1-5.2-5.1-8.9-9.3-8.3-2.9.4-5.1 2.7-6.1 5.8l-16.6 1Zm17.7 2.6c-.6-4.6 1.8-8.8 5.4-9.3s7.1 2.8 7.8 7.4-1.8 8.8-5.4 9.3-7.2-2.8-7.8-7.4Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#f4e2ca",
        }}
      />
      <path
        className="cls-17"
        d="M698.2 380.4c-4.8 5-16.3 26.4-33.3 32.9-5.5 2.1-69.9-23-80.1-28.5-6.3-3.4-17.9-13.2-31.7-12.1-16.8 1.3-13.3 30.4-1.3 32.3 10.3 1.6 11.6-7 18.8-4.1 37.5 14.5 80.6 48.4 97.2 48.4 18.2 0 57.6-41.5 57.6-41.5-1-21.2-27.2-27.4-27.2-27.4Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-38"
        d="m743.5 378.5-15.9 37.4s-22.6-12.3-35.4-27.7-2.2-.5-2.2-.5l15.5-24 38 14.8"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-45"
        d="M705.5 363.8s-7.6 16.8-13.3 24.4"
        transform="translate(.7 .2)"
      />
      <path className="cls-45" d="m616.3 358.9-2 16.5" />
      <path
        className="cls-45"
        d="M653.9 334.2s30.4 6.1 49.8-5.4M691 467.2s-7.9 15-18.9 15"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-46"
        d="M509.3 484.4s18.2 19.5 31 26.2M419 593s12.7 12.2 31.4 15.8M461.6 646.9s10.2 7.6 32.8 6"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-17"
        d="M693.2 314.4a20.71 20.71 0 0 1-1.7-2.4l-2.9-3.2-2.1 3.2-27.9-.9v2.1a2.26 2.26 0 0 1-2 2.2l-8.8.9c22.2 15.5 56 1.9 56 1.9a18.24 18.24 0 0 1-10.6-3.8Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M381.8 253.2s18.2 9.3 11 46.9c0 0-6.5 18.1-1.9 25.8 0 0 14.8 3.7 24.7 1.2l32.2-5.2 27-6 2.5-21.6s4-14.6 6.4-20.6a80.94 80.94 0 0 0 2.8-8.3 169.61 169.61 0 0 1 6.2-18.2 68.07 68.07 0 0 0-7.6-2.6s-11.6 42.1-20.6 48.1c0 0-37.3 8.1-62.1 1.1 0 0-4.2-36.3-15-45.2 0 .1-4.3 2.1-5.6 4.6Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#26211d",
        }}
      />
      <path
        d="M413.7 312a9.31 9.31 0 0 0-10.6-5.4l.2-2h-34.7l2.8 25.1h29.4l.5-5.3a16.67 16.67 0 0 0 5.9-.1 8.65 8.65 0 0 0 6.5-12.3Zm-2.7 4.5a4.33 4.33 0 0 0-.1.5 3.09 3.09 0 0 0-.2.8v.1l-.1.2-.3.6c-.1.1-.1.2-.2.3 0-.1.2-.2 0 0a2.65 2.65 0 0 0-.5.6l-.1.1-.2.1c-.2.1-.5.3-.7.4l-.5.2a2.92 2.92 0 0 1-.9.2 13 13 0 0 1-5.2.1l1-10.4.3-.1a6.51 6.51 0 0 1 3.4-.2c.2.1.5.1.7.2l.2.1.2.1.6.3.3.2.2.1c.3.3.7.6 1 .9l.2.2.1.1c.2.2.3.5.5.7l.3.6.2.5a6.37 6.37 0 0 1 .2.7v.4a1.9 1.9 0 0 0-.4 1.4Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#f4f4f4",
        }}
      />
      <path
        d="M366.9 344.9c-2.3-4.6.9-17.1 10-19.6 7.5-2.1 9.7-.7 22.1 2 10.2 2.2 25.7-1.9 42.8-3.9"
        transform="translate(.7 .2)"
        style={{
          stroke: "#8e5a50",
          strokeWidth: ".75px",
          strokeMiterlimit: 10,
          fill: "#ad6b55",
        }}
      />
      <path
        className="cls-24"
        d="M410.2 240.8a35.82 35.82 0 0 0 11.3 5l1 5s-17.9.3-32.2-3.6c0 0 11.1-3.9 19.9-6.4Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M647.4 262.9c-.1 1.2-.3 2.3-.5 3.5a10.07 10.07 0 0 0-.3 2.5 2 2 0 0 0 .4 1.5 1.79 1.79 0 0 0 1.7.4 2.79 2.79 0 0 0 2-1.8c.2-.3-.3-.6-.5-.3a2.16 2.16 0 0 1-2.1 1.5 1 1 0 0 1-1.1-.9v-.1a21.05 21.05 0 0 1 .2-2.5c.2-1.3.5-2.5.6-3.8.1-.3-.4-.4-.4 0Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#e58c7a",
        }}
      />
      <path
        className="cls-18"
        d="M642.6 250.1c.3-.9-.1-1.3-1.6-1.5a11.66 11.66 0 0 0-4.5.6c-2.9 1-4.2 3.6-3.4 3.1a13.67 13.67 0 0 1 5.6-1.8c1.6-.4 3.7.2 3.9-.4ZM652.8 249.6c-.6-1-.1-1.7 1.6-2.2a12.36 12.36 0 0 1 5.4-.3c3.6.6 5.6 3.5 4.5 3.1a16 16 0 0 0-6.9-1.1c-1.9.1-4.2 1.3-4.6.5Z"
        transform="translate(.7 .2)"
      />
      <ellipse className="cls-51" cx={656.4} cy={260.4} rx={1.2} ry={2.4} />
      <ellipse className="cls-51" cx={638} cy={261.4} rx={1.2} ry={2.4} />
      <path
        className="cls-7"
        d="M650.9 277.9a4.86 4.86 0 0 1-4.3-1.1.19.19 0 0 1 0-.3h.1s2.4-.2 4-.4 3.9-.7 3.9-.7a.2.2 0 0 1 .2.2 4.75 4.75 0 0 1-3.9 2.3Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M170.3 223.5c.3-1.5-.5-2-3-1.8a21.75 21.75 0 0 0-7.1 2.2c-3.7 1.9-5.2 6.3-4.2 5.5 2.1-1.6 3.3-2.5 8.1-4.2 2.6-.9 6-.6 6.2-1.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#052620",
        }}
      />
      <path
        className="cls-16"
        d="m290.7 357.6-9.5-13.9a9.65 9.65 0 0 0-12.1-3.5l-58.6 23c-4.4 2-11.9 2.3-16.1 0-9.2-5.1-13.4-8.5-16.9-13.4-1.1-1.9-2.4-4.1-3.9-6.5-7.9-12.4-22.3-31.4-48.2-56a19.47 19.47 0 0 0-11.1-5.2c-11.5-1.3-33.6 2.2-46.2 42.3L13.7 429c.1-.2 11.5 23.6 51.2 35.2l63.5-42.7 34.4-21.6s24.7 26.5 55.6 5.6l68.3-33.2a10.15 10.15 0 0 0 4.7-13.5c-.2-.3-.4-.8-.7-1.2Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-53"
        d="M160.5 398.3s-33.1-19.1-41.9-36M198.1 366.5s-4.8 5.9-2.5 12.8"
        transform="translate(.7 .2)"
      />
      <path
        d="M47.2 365.6s54.4 65.2 81.6 55.2l-63.9 43.6s-30.1-4.5-51.2-35.2Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#b9271a",
        }}
      />
      <path
        className="cls-55"
        d="M112 220.8c2-2.4 2.3-5.5 2.8-8.5a17.17 17.17 0 0 1 4-9 23.25 23.25 0 0 1 7.2-6.4 12.11 12.11 0 0 1 5.3-.9 19.57 19.57 0 0 0 5.4-.2c3.6-.8 6.6-3.2 9.5-5.5.5-.4-.2-1.1-.7-.7-2.6 2.1-5.3 4.3-8.6 5.1a20.89 20.89 0 0 1-5.6.2 11.17 11.17 0 0 0-5.1.8c-2.9 1.2-5.3 3.6-7.3 5.9a21.2 21.2 0 0 0-4.7 8.4c-.8 3.3-.7 7.2-3 10-.4.6.3 1.4.8.8Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-55"
        d="M134.6 202.1c-3.8.6-5.7 4.4-6.8 7.6-1.2 3.4-2.2 8-6 9.4-.6.2-.3 1.2.3 1 3.6-1.3 5.1-5 6.1-8.4s2.5-8 6.7-8.7c.6-.1.4-1-.3-.9Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M152.7 406.5a29.38 29.38 0 0 0-45.8 29.7Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#fffd54",
        }}
      />
      <path
        className="cls-8"
        d="M347.2 420.8H362a5.59 5.59 0 0 1 5.6 5.6v7.8a5.59 5.59 0 0 1-5.6 5.6h-14.8a5.59 5.59 0 0 1-5.6-5.6v-7.8a5.53 5.53 0 0 1 5.6-5.6ZM377.2 412.8H393a5.59 5.59 0 0 1 5.6 5.6v15.8a5.59 5.59 0 0 1-5.6 5.6h-15.8a5.59 5.59 0 0 1-5.6-5.6v-15.8a5.53 5.53 0 0 1 5.6-5.6ZM377.2 443.8H388a5.59 5.59 0 0 1 5.6 5.6v15.8a5.59 5.59 0 0 1-5.6 5.6h-10.8a5.59 5.59 0 0 1-5.6-5.6v-15.8a5.53 5.53 0 0 1 5.6-5.6ZM351.2 443.8H362a5.59 5.59 0 0 1 5.6 5.6v16.8a5.59 5.59 0 0 1-5.6 5.6h-10.8a5.59 5.59 0 0 1-5.6-5.6v-16.8a5.53 5.53 0 0 1 5.6-5.6Z"
        transform="translate(.7 .2)"
      />
      <path
        className="cls-18"
        d="M704 239c-2.8-5.6-2.9-12.1-4.6-18.1-3-10.7-10-20.4-20.3-24.2a24.83 24.83 0 0 0-15.7-.6 27.49 27.49 0 0 0-3.6 1.5c-1.4.7-2.6 1.6-4.2 1.3a33.82 33.82 0 0 1-3.4-1.1 23.18 23.18 0 0 0-3.8-.6 20.88 20.88 0 0 0-13.4 4.1 23.06 23.06 0 0 0-8.3 12.6c-1.6 5.7-1.8 11.9-4.3 17.3a69.3 69.3 0 0 0-4.8 13.9c-1.2 5-1 8.2 1.2 13 1 2.1 3.1 3.5 4.4 5.5a20.16 20.16 0 0 1 2.5 6.1c.6 2.1 1.6 4.3 3.8 4.8a1.55 1.55 0 0 0 1.9-1.1c0-.1.1-.3.1-.4.3-4.4-1.6-8.3-2.6-12.4a13.41 13.41 0 0 1-.4-6.3c.4-2.4.8-4.8 1.1-7.2.6-4.4 1.2-9 3.6-12.7 1.8-2.7 4.7-5.2 7.9-5.3a1.58 1.58 0 0 0 1.5.1 1.61 1.61 0 0 0 1.7-.8c4.7-2.3 10.2-4.6 15.1-1.9a9 9 0 0 1 3.4 3.3l-.1.2s1.2 14.9 5.7 21.7a6.64 6.64 0 0 0 6.3 3l1.1-.1-2.5-1.1s-3.4-1.5-6.2-10.9a16.92 16.92 0 0 0 4.8 7.9c5.1 4 9.9-1.5 15.2-1.2 4.6.2 8.5 4 7.6 9.1-.5 3-2.2 5.7-3.6 8.3-1.1 2.1-2.9 5-1.6 7.4s4.4 2.4 6.6 1.6a14.79 14.79 0 0 0 6.1-4.7c3.5-4.4 6.9-9.9 7.5-15.7.4-6.3-3.2-11.2-5.7-16.3Z"
        transform="translate(.7 .2)"
      />
      <path
        d="M269.9 468.3c-4.3-17.3-32.7-15-32.7-15-16.5-66.2-33.9-60.2-55.1-61.4-13.9-.8-116.6 71.5-116.6 71.5-27.8-3.1-51.8-34.3-51.8-34.3A92.4 92.4 0 0 0-.5 446.9v83.4c19.1 18.1 54.8 29.8 87.5 17.4 25.4-9.7 74.2-46.7 93.5-84.7v.1c.1-.4.8-.5.8 0 .7 4.5 2 9 3.1 13.5 3.5 14.2 7.3 28.4 11.2 42.6 1.7 6.2 3.4 12.5 5.2 18.8.9 3.2 1.7 6.5 2.8 9.6.2.5-.7.8-.9.2-1.3-3.8-2.3-7.7-3.4-11.6-3.9-13.9-7.7-27.9-11.3-41.9-1.7-6.5-3.4-13.1-5-19.6a108.4 108.4 0 0 1-2.5-11.3l-.4 5.5a51.5 51.5 0 0 1-13 30.7c-12.4 13.7-30.2 33.5-27.8 32.7 0 0 9.1 11.9 11.5 13.8 0 0 8.9 13.5 17.2 17.2 0 0 30.4-11.9 35.3-15.2 0 0 8.3 7.3 11.8 14 0 0 21.8 5.8 35.6-11.5a355.1 355.1 0 0 0-.5-38.6c.1.2 23.9-26.4 19.7-43.7Zm-20.3 43.4-2.4-11.4c-1.9-9.5-3.9-19-5.9-28.5-.8-3.9-1.6-7.8-2.5-11.7a62.28 62.28 0 0 0-1.5-6.2.46.46 0 0 1 .9-.2c.7 2.4 1.3 4.9 1.8 7.4 3.7 16.8 6.9 33.6 10.5 50.4.1.5-.8.8-.9.2Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#e6e6e6",
        }}
      />
    </g>
    <g
      style={{
        clipPath: "url(#clip-path)",
      }}
      id="Layer_2"
      data-name="Layer 2"
    >
      <path
        d="M415.4 230.5c-3.5.1-5.4-2.8-6.2-4.1-.1-.2-.1-.5.1-.5 0 0 3.8 0 6.2-.1s6.3-.6 6.3-.6c.2 0 .4.3.2.7-.6 1.3-2.9 4.5-6.6 4.6Z"
        transform="translate(.7 .2)"
        style={{
          fill: "#bb4753",
        }}
      />
      <path
        className="cls-7"
        d="M422 224.8c1 .6-3 2-6.7 2.2-3.1.2-6.6-1.3-6.4-1.7Z"
        transform="translate(.7 .2)"
      />
    </g>
  </svg>
  )
}

export default SvgRelationshipOneAOneTwo